import Vue from 'vue'

export default {
  url: process.env.VUE_APP_AWS_APPSYNC_ENDPOINT,
  region: process.env.VUE_APP_AWS_APPSYNC_REGION,
  auth: {
    type: process.env.VUE_APP_AWS_APPSYNC_AUTH_TYPE,
    jwtToken: async () => {
      const currentSession = await Vue.prototype.$Amplify.Auth.currentSession()
      return currentSession.getAccessToken().getJwtToken()
    },
  },
  api: 'http://127.0.0.1:8000/api', /* type http://crm-api.id-a.pl/api if you want to use demo API */
  prefix: 'auth',
  paths: {
    login: 'login',
    logout: 'logout',
    getUser: 'user',
    refreshToken: 'refresh-token',
    editUser: 'user',
    changePassword: 'user-password',
  },
  loginWithEmail: false,
  loginFieldName: 'username',
  loginEditable: true,
  loginMinLength: 4,
  loginMaxLength: 100,
  loginRegex: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
  passwordFieldName: 'password',
  passwordEditable: true,
  passwordMinLength: 1,
  passwordMaxLength: 100,
  customFields: [
    {
      name: 'name',
      regex: /^.{0,100}$/,
      editable: true,
      minLength: 0,
      maxLength: 100,
      required: true,
    },
  ],
}
